import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class UserNotifyType extends SnModel {
  @Expose()
  public badge: string;

  @Expose()
  public organization: string;

  @Expose()
  public email: string;

  @Expose()
  public firstName: string;

  @Expose()
  public homeOrganization: string;

  @Expose()
  public id: string;

  @Expose()
  public lastName: string;

  @Expose()
  public mobilePhone: string;

  @Expose()
  public title: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
